import { __spreadArray } from "tslib";
import { useState, useMemo, useCallback } from 'react';
import { indexIncludes } from './utils';
import createItemsTree from './create-items-tree';
import moveHighlightOneStep from './move-highlight';
export default function useHighlightedMenu(_a) {
    var items = _a.items, hasExpandableGroups = _a.hasExpandableGroups, _b = _a.isInRestrictedView, isInRestrictedView = _b === void 0 ? false : _b;
    var _c = useState([]), targetIndex = _c[0], setTargetIndex = _c[1];
    var _d = useState([]), expandedIndex = _d[0], setExpandedIndex = _d[1];
    var _e = useMemo(function () { return createItemsTree(items); }, [items]), getItem = _e.getItem, getItemIndex = _e.getItemIndex, getSequentialIndex = _e.getSequentialIndex;
    var targetItem = useMemo(function () { return getItem(targetIndex); }, [targetIndex, getItem]);
    var isHighlighted = useCallback(function (item) {
        var index = getItemIndex(item);
        return indexIncludes(index, targetIndex);
    }, [targetIndex, getItemIndex]);
    var isExpanded = useCallback(function (group) {
        var index = getItemIndex(group);
        return indexIncludes(index, expandedIndex);
    }, [expandedIndex, getItemIndex]);
    var moveHighlight = useCallback(function (direction) {
        var getNext = function (index) {
            var nextIndex = getSequentialIndex(index, direction);
            var item = getItem(nextIndex || [-1]);
            return nextIndex && item ? { index: nextIndex, item: item } : null;
        };
        var nextIndex = moveHighlightOneStep({
            startIndex: targetIndex,
            expandedIndex: expandedIndex,
            getNext: getNext,
            hasExpandableGroups: hasExpandableGroups,
            isInRestrictedView: isInRestrictedView
        });
        if (nextIndex) {
            setTargetIndex(nextIndex);
        }
    }, [targetIndex, expandedIndex, getItem, getSequentialIndex, hasExpandableGroups, isInRestrictedView]);
    var highlightItem = useCallback(function (item) {
        setTargetIndex(getItemIndex(item));
    }, [getItemIndex]);
    var expandGroup = useCallback(function (group) {
        var groupIndex = group ? getItemIndex(group) : targetIndex;
        var firstChildIndex = __spreadArray(__spreadArray([], groupIndex, true), [0], false);
        // move to the first child item unless in restricted mode
        setTargetIndex(isInRestrictedView ? groupIndex : firstChildIndex);
        setExpandedIndex(groupIndex);
    }, [targetIndex, getItemIndex, isInRestrictedView]);
    var collapseGroup = useCallback(function () {
        if (expandedIndex.length > 0) {
            setTargetIndex(expandedIndex);
            setExpandedIndex(expandedIndex.slice(0, -1));
        }
    }, [expandedIndex]);
    var reset = useCallback(function () {
        setTargetIndex([]);
        setExpandedIndex([]);
    }, []);
    return {
        targetItem: targetItem,
        isHighlighted: isHighlighted,
        isExpanded: isExpanded,
        moveHighlight: moveHighlight,
        highlightItem: highlightItem,
        expandGroup: expandGroup,
        collapseGroup: collapseGroup,
        reset: reset
    };
}
//# sourceMappingURL=use-highlighted-menu.js.map